import { getInitialTimezone } from '~/utils/dayjs';
import { useSyncExternalStore } from 'react';
import i18next from 'i18next';

function subscribe(callback: () => void) {
  i18next.on('timezoneChanged', callback);
  return () => {
    i18next.off('timezoneChanged', callback);
  };
}

export function useShopTimezone(): string {
  return useSyncExternalStore(subscribe, getInitialTimezone, getInitialTimezone);
}
